import { useMediaRemote, useMediaState } from '@vidstack/react';
import { useTranslation } from 'react-i18next';
import { PlayerIconButton } from './SmartPlayerUI';

const SPEED_STEPS = [0.5, 1, 1.5, 2, 4];

export const SmartPlayerSpeed = () => {
    const { t } = useTranslation('smartPlayer');
    const remote = useMediaRemote();
    const currentRate = useMediaState('playbackRate');

    const handleSpeedCycle = () => {
        const currentIndex = SPEED_STEPS.indexOf(currentRate);
        remote.changePlaybackRate(
            SPEED_STEPS[
                currentIndex === SPEED_STEPS.length - 1 ? 0 : currentIndex + 1
            ],
        );
    };

    return (
        <PlayerIconButton
            active={currentRate !== 1}
            onClick={handleSpeedCycle}
            style={{ width: '36px' }}
            title={t('controls.speed')}
        >
            {currentRate}x
        </PlayerIconButton>
    );
};
